import { render, staticRenderFns } from "./IconSvgCalculator.vue?vue&type=template&id=1f491e24&scoped=true&"
import script from "./IconSvgCalculator.vue?vue&type=script&lang=js&"
export * from "./IconSvgCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f491e24",
  null
  
)

export default component.exports